<template>
  <div class="mall-my-profile">
    <header class="mall-my-list__head">
      <h1>개인정보 확인 / 수정</h1>
      <p>기관·담당자 정보는 계정 설정에서 관리합니다.</p>
    </header>

    <section v-if="member" class="mall-my-profile__card">
      <dl>
        <div v-if="isKakaoMember">
          <dt>로그인</dt>
          <dd>{{ kakaoAccountLabel }}</dd>
        </div>
        <div v-else>
          <dt>아이디</dt>
          <dd>{{ member.userId }}</dd>
        </div>
        <div>
          <dt>기관명</dt>
          <dd>{{ member.orgName || '-' }}</dd>
        </div>
        <div>
          <dt>기관 기호</dt>
          <dd>{{ member.longtermCode || '-' }}</dd>
        </div>
        <div>
          <dt>담당자</dt>
          <dd>{{ member.bossName || '-' }}</dd>
        </div>
        <div>
          <dt>휴대폰</dt>
          <dd>{{ member.bossPhone || '-' }}</dd>
        </div>
        <div>
          <dt>이메일</dt>
          <dd>{{ member.bossEmail || '-' }}</dd>
        </div>
      </dl>

      <div class="mall-my-profile__actions">
        <router-link to="/my-info" class="mall-my-profile__primary">정보 수정하기</router-link>
        <router-link v-if="!isKakaoMember" to="/find-password" class="mall-my-profile__ghost">
          비밀번호 변경
        </router-link>
      </div>
      <button
        type="button"
        class="mall-my-profile__withdraw"
        :disabled="withdrawing"
        @click="onWithdraw"
      >
        {{ withdrawing ? '탈퇴 중...' : '계정 탈퇴' }}
      </button>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useMemberAuth } from '@/composables/useMemberAuth'

const router = useRouter()
const { member, withdraw } = useMemberAuth()
const isKakaoMember = computed(() => member.value?.loginType === 'kakao')
const kakaoAccountLabel = computed(() =>
  member.value?.oauthEmail ? `카카오 계정 · ${member.value.oauthEmail}` : '카카오 계정',
)
const withdrawing = ref(false)

const onWithdraw = async () => {
  if (withdrawing.value) {
    return
  }
  if (
    !window.confirm(
      '정말 탈퇴할까요?\n카카오 계정이면 같은 카카오로 다시 가입할 수 있습니다.\n주문 기록은 보관됩니다.',
    )
  ) {
    return
  }
  withdrawing.value = true
  try {
    await withdraw()
    window.alert('탈퇴가 완료되었습니다.')
    await router.push({ name: 'dashboard' })
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '탈퇴에 실패했습니다.')
  } finally {
    withdrawing.value = false
  }
}
</script>

<style lang="scss" src="./MallMyProfilePage.scss"></style>
